import { useEffect } from 'react';
import useSegments from 'Client/hooks/useSegments';
import { useLogger } from 'AppShell/logger/LoggerProvider';
import { windowObjectIndicatesWebView } from 'AppShell/appBridge/AppBridge';
import useAppshellCookies from 'AppShell/hooks/useAppshellCookies';
import { LegacyBooleanAsString } from 'AppShell/appshell_types';

export const useWebviewDetectionHealer = () => {
    const segments = useSegments();
    const logger = useLogger();
    const [, setIsWebViewCookie] = useAppshellCookies<any, LegacyBooleanAsString>('isWebView');
    const [, , , removeAppVersionCookie] = useAppshellCookies('APP_VERSION');

    useEffect(() => {
        const isApp = windowObjectIndicatesWebView();
        if (segments.isWebView && !isApp) {
            logger.error(`Incorrect webview detection`);

            setIsWebViewCookie('false');
            removeAppVersionCookie();
            window.location.replace('/');
        }
    }, [segments.isWebView, logger, setIsWebViewCookie, removeAppVersionCookie]);
};
